import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import DailyParts from './DailyParts';
import PF2MTabs from '~/components/PF2MTabs';

const tabs = [
  { key: 0, label: 'Ciclos' },
];

const UndergroundDailyParts = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<DailyParts />) : null}
    </>
  );
};

export default withStyles(styles)(UndergroundDailyParts);
